import { atomWithStorage, useHydrateAtoms } from 'jotai/utils';

// Import specific types and type guards
import { isPermission, isRole } from '@/types/auth';
import { createCookieSetStorage } from '@/utils/cookie-storage';

import type { Permission, Role } from '@/types/auth';

// Create specific storage instances using the utility
const permissionCookieStorage = createCookieSetStorage<Permission>(
  isPermission,
  {
    expires: 1, // 1 day
  }
);

const roleCookieStorage = createCookieSetStorage<Role>(isRole, {
  expires: 1, // 1 day
});

// Atoms for permissions and roles using the typed storage
// Pass the storage object directly
export const userPermissionsAtom = atomWithStorage<Set<Permission>>(
  'user-permissions',
  new Set<Permission>(),
  permissionCookieStorage
);

export const userRolesAtom = atomWithStorage<Set<Role>>(
  'user-roles',
  new Set<Role>(),
  roleCookieStorage
);

interface HydrateAuthParams {
  permissions?: Permission[];
  roles?: Role[];
}

/**
 * @deprecated Use `withServerAuth()` wrapper in `getServerSideProps` instead.
 * Auth atoms are now hydrated automatically via `AuthHydrationProvider`
 * when pages use `withServerAuth()`. See DEV-5322 for migration details.
 */
export const useHydrateAuthAtoms = ({
  permissions = [],
  roles = [],
}: HydrateAuthParams = {}) => {
  useHydrateAtoms([
    [userPermissionsAtom, new Set(permissions.filter(isPermission))],
    [userRolesAtom, new Set(roles.filter(isRole))],
  ] as const);
};
